<template>
    <div>
        <el-row style="margin-bottom:10px;">
            <!-- <el-button v-if="addOpportunityBusinessCheckImage"
           @click=" $form('addOpportunityBusinessCheckImage')"
           size='small'
           type="primary"
           style="float:right"
           icon='el-icon-circle-plus'
         >添加填写项约束
         </el-button> -->
        </el-row>

        <!-- <mytable
         :tableColums='tableColums_getMicrolectureTrainRuleScoreOne'
         api='getMicrolectureTrainRuleScoreOne'
         xupdateapi='updateSysKeyProject'
         :height="H-165" >
       </mytable> -->

        <myform :viewobj='{

            updateSysKeyProject: ["修改关键值", "el-icon-edit-outline"],
            $succeed$: getMicrolectureTrainRuleScoreOne
        }' @close='$form("updateSysKeyProject", "reset")'>
            <hide slot='mtrsId' />
            <hide slot='skpValueTwo' />
            <hide slot='obciKeyLabel' />
            <template v-slot:skpValue="{ Myformdata }">
                <el-select v-model='Myformdata.skpValue' clearable>
                    <el-option v-for="item in obcKeyArray" :key="item.key" :label="item.label" :value="item.key">
                    </el-option>
                </el-select>
            </template>
            <!-- <template v-slot:obciNecessary="{Myformdata}" >
            <el-radio v-model="Myformdata.obciNecessary" :label="obcKeyOne">是</el-radio>
            <el-radio v-model="Myformdata.obciNecessary" :label="obcKeyTwo">否</el-radio>
         </template> -->
        </myform>
        <el-card style="width: 95%;margin: 20px auto;position: relative;overflow:inherit;height: 90%;">
            <div
                style="position: absolute;top: -5%;font-size: 25px;background-color: white;width: 30%;text-align: center;color:#409EFF ;">
                <el-button type="text" style="margin: 0 10px;"
                    :style="{ color: OtherTypeid == 1 ? '#409EFF' : 'black' }" @click="OtherTypeid = 1">评分规则</el-button>
            </div>

            <div style="width: 97%;margin: 10px auto;overflow-y: auto;height: 95%;" v-if="OtherTypeid == 1">
                <div style="display: flex;flex-wrap: wrap;align-items: center;"
                    v-if="getMicrolectureTrainRuleScoreOne_data.data">
                    <div style="width: 50%;display: flex;align-items: center;color: red;">
                        <div style="width: 30%;margin: 10px;">
                            评分项
                        </div>
                        <div style="width: 60%;margin: 10px 0;">
                            <span>是否启用</span>
                            <span style="width: 80px;margin-left: 100px;">评分权重</span>
                        </div>
                    </div>
                    <div style="width: 50%;display: flex;align-items: center;color: red;">
                        <div style="width: 30%;margin: 10px 0;">
                            评分项
                        </div>
                        <div style="width: 60%;margin: 10px;">
                            <span>是否启用</span>
                            <span style="width: 80px;   margin-left: 100px;">评分权重</span>
                        </div>
                    </div>
                    <!-- <div style="width: 50%;display: flex;align-items: center;">
                        <div style="width: 30%;margin: 10px 0;">
                            {{ getMicrolectureTrainRuleScoreOne_data.data.mtrsEight }}:
                        </div>
                        <div style="width: 65%;margin: 10px 0;">
                            <el-switch v-model="getMicrolectureTrainRuleScoreOne_data.data.mtrsEightStatus"
                                active-text="是" inactive-text="否" :active-value="2" :inactive-value="1">
                            </el-switch>
                            <el-input type="number" v-model="getMicrolectureTrainRuleScoreOne_data.data.mtrsEightWeight"
                                placeholder="请输入评分权重" style="width: 80px;  margin-left: 100px;"></el-input>
                        </div>
                    </div> -->
                    <div style="width: 50%;display: flex;align-items: center;">
                        <div style="width: 30%;margin: 10px 0;">
                            {{ getMicrolectureTrainRuleScoreOne_data.data.mtrsFive }}:
                        </div>
                        <div style="width: 60%;margin: 10px 0;">
                            <el-switch v-model="getMicrolectureTrainRuleScoreOne_data.data.mtrsFiveStatus"
                                active-text="是" inactive-text="否" :active-value="2" :inactive-value="1">
                            </el-switch>
                            <el-input type="number" v-model="getMicrolectureTrainRuleScoreOne_data.data.mtrsFiveWeight"
                                placeholder="请输入评分权重" style="width: 80px;   margin-left: 100px;"></el-input>
                        </div>
                    </div>
                    <div style="width: 50%;display: flex;align-items: center;">
                        <div style="width: 30%;margin: 10px 0;">
                            {{ getMicrolectureTrainRuleScoreOne_data.data.mtrsFour }}:
                        </div>
                        <div style="width: 60%;margin: 10px 0;">
                            <el-switch v-model="getMicrolectureTrainRuleScoreOne_data.data.mtrsFourStatus"
                                active-text="是" inactive-text="否" :active-value="2" :inactive-value="1">
                            </el-switch>
                            <el-input type="number" v-model="getMicrolectureTrainRuleScoreOne_data.data.mtrsFourWeight"
                                placeholder="请输入评分权重" style="width: 80px;   margin-left: 100px;"></el-input>
                        </div>
                    </div>
                    <div style="width: 50%;display: flex;align-items: center;">
                        <div style="width: 30%;margin: 10px 0;">
                            {{ getMicrolectureTrainRuleScoreOne_data.data.mtrsThree }}:
                        </div>
                        <div style="width: 60%;margin: 10px 0;">
                            <el-switch v-model="getMicrolectureTrainRuleScoreOne_data.data.mtrsThreeStatus"
                                active-text="是" inactive-text="否" :active-value="2" :inactive-value="1"
                                @change="changeKey($event, 'mtrsThree')">
                            </el-switch>
                            <el-input type="number" v-model="getMicrolectureTrainRuleScoreOne_data.data.mtrsThreeWeight"
                                placeholder="请输入评分权重" @input="inputChange($event, 'mtrsThreeWeight')"
                                style="width: 80px;   margin-left: 100px;"></el-input>
                        </div>
                    </div>
                    <div style="width: 50%;display: flex;align-items: center;">
                        <div style="width: 30%;margin: 10px 0;">
                            {{ getMicrolectureTrainRuleScoreOne_data.data.mtrsTwo }}:
                        </div>
                        <div style="width: 60%;margin: 10px 0;">
                            <el-switch v-model="getMicrolectureTrainRuleScoreOne_data.data.mtrsTwoStatus"
                                active-text="是" inactive-text="否" :active-value="2" :inactive-value="1"
                                @change="changeKey($event, 'mtrsTwo')">
                            </el-switch>
                            <el-input type="number" v-model="getMicrolectureTrainRuleScoreOne_data.data.mtrsTwoWeight"
                                placeholder="请输入评分权重" @input="inputChange($event, 'mtrsTwoWeight')"
                                style="width: 80px;   margin-left: 100px;"></el-input>
                        </div>
                    </div>
                    <div style="width: 50%;display: flex;align-items: center;">
                        <div style="width: 30%;margin: 10px 0;">
                            {{ getMicrolectureTrainRuleScoreOne_data.data.mtrsOne }}:
                        </div>
                        <div style="width: 60%;margin: 10px 0;">
                            <el-switch v-model="getMicrolectureTrainRuleScoreOne_data.data.mtrsOneStatus"
                                active-text="是" inactive-text="否" :active-value="2" :inactive-value="1"
                                @change="changeKey($event, 'mtrsOne')">
                            </el-switch>
                            <el-input type="number" v-model="getMicrolectureTrainRuleScoreOne_data.data.mtrsOneWeight"
                                placeholder="请输入评分权重" @input="inputChange($event, 'mtrsOneWeight')"
                                style="width: 80px;   margin-left: 100px;"></el-input>
                        </div>
                    </div>
                    <div style="width: 50%;display: flex;align-items: center;">
                        <div style="width: 30%;margin: 10px 0;">
                            {{ getMicrolectureTrainRuleScoreOne_data.data.mtrsSix }}:
                        </div>
                        <div style="width: 60%;margin: 10px 0;">
                            <el-switch v-model="getMicrolectureTrainRuleScoreOne_data.data.mtrsSixStatus"
                                active-text="是" inactive-text="否" :active-value="2" :inactive-value="1"
                                @change="changeKey($event, 'mtrsSix')">
                            </el-switch>
                            <el-input type="number" v-model="getMicrolectureTrainRuleScoreOne_data.data.mtrsSixWeight"
                                placeholder="请输入评分权重" @input="inputChange($event, 'mtrsSixWeight')"
                                style="width: 80px;   margin-left: 100px;"></el-input>
                        </div>
                    </div>


                    <div style="width: 90%;margin: 30px auto;display: flex;flex-direction: row-reverse;">
                        <el-button type="success" @click="updataClick">确定编辑</el-button>
                        <el-button type="primary" @click="BtnClick" style="margin-right: 30px;">刷新</el-button>
                    </div>
                </div>
            </div>
        </el-card>

    </div>
</template>

<script>
export default {
    data() {
        return {
            OtherTypeid: 1,
            theProjectId: "",
            obcKeyOne: 1,
            obcKeyTwo: 2,
            obcKeyArray: [
                { key: 1, label: "1" },
                { key: 2, label: "2" },


            ],

            tableColums_getMicrolectureTrainRuleScoreOne: {
                $selection: false,

                // oiType: '限制字段key',

                skpDes: '限制字段名称',

                skpValue: ['是否展示', , '@v-if: 1:否, 2:是 '],

                $operation: [
                    '操作', 200,
                    this.updateSysKeyProject && `@text: 编辑#success
                   @click: $form("updateSysKeyProject",$row)
                  `,

                ],

            },
        }
    },

    methods: {
        BtnClick(){
            this.getMicrolectureTrainRuleScoreOne({ projectId: this.theProjectId });
        },
        updataClick() {
            this.$confirm('是否确认编辑, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.updateMicrolectureTrainRuleScore(this.getMicrolectureTrainRuleScoreOne_data.data)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });
        },
        inputChange(e, key) {
            console.log(e, key);
            if (this.OtherTypeid == 5) {
                const formData = new FormData();
                formData.append(key, e);
                formData.append('mtrsId', this.getMicrolectureTrainRuleScoreOne_data.data.mtrsId);
                this.updateMicrolectureTrainRuleScore(formData)
            }
        },
        changeKey(e, key) {
            console.log(e, key);
            if (this.OtherTypeid == 5) {
                const formData = new FormData();
                formData.append(key, e);
                formData.append('mtrsId', this.getMicrolectureTrainRuleScoreOne_data.data.mtrsId);
                this.updateMicrolectureTrainRuleScore(formData)
            }
        },
        myform(submit, Myformdata) {
            Myformdata.projectId = this.theProjectId;
            var oiType = Myformdata.oiType;
            this.obcKeyArray.forEach(element => {
                if (element.key == oiType) {
                    Myformdata.obciKeyLabel = element.label;
                }
            });
            submit();
        },
    },
    created() {
        this.theProjectId = A.local('$projectId');
        this.getMicrolectureTrainRuleScoreOne({ projectId: this.theProjectId });
        this.getSysKeyProjectVisitorList({ projectId: this.theProjectId });
    }
}
</script>

<style scoped="scoped">
div .el-button {
    font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/views/rule/weikeRulurs.vue